const PAGES = {
  EQUITY: {
    light: "/svg/pages/equity_light.svg",
    dark: "/svg/pages/equity_dark.svg",
  },
  CONVERSION: {
    light: "/svg/pages/conversion_light.svg",
    dark: "/svg/pages/conversion_dark.svg",
  },
  EMOTIONAL: {
    light: "/svg/pages/emotional_light.svg",
    dark: "/svg/pages/emotional_dark.svg",
  },
  ADVERTISING: {
    light: "/svg/pages/advertising_light.svg",
    dark: "/svg/pages/advertising_dark.svg",
  },
  VISIBILITY: {
    light: "/svg/pages/visibility_light.svg",
    dark: "/svg/pages/visibility_dark.svg",
  }, 
  REPUTATION: {
    light: "/svg/pages/reputation_light.svg",
    dark: "/svg/pages/reputation_dark.svg",
  },
  EXCLUSIVE_QUESTIONS: {
    light: "/svg/pages/exclusive_question_light.svg",
    dark: "/svg/pages/exclusive_question_dark.svg",
  },
  REPORTS: {
    light: "/svg/pages/report_builder_light.svg",
    dark: "/svg/pages/report_builder_dark.svg",
  },
};

export default PAGES;
